import StencilHTMLElement from "./stencil-element";

class ProductOutOfStockBanner extends StencilHTMLElement {
  name="ProductOutOfStockBanner";
  constructor() {
    super();
    this.openProductContactForm = this.openProductContactForm.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.openProductContactForm.bind(this));
  }

  openProductContactForm(e) {
    const variantId = e.currentTarget.dataset.variantId;
    const modal = document.querySelector(`.product-out-of-stock-modal-${variantId}`);
    const modalContent = new bootstrap.Modal(modal, {
    });
    modalContent.show();
    
  }
}

export default ProductOutOfStockBanner;
